import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLoading } from "../../context/LoadingContext";
import "./Loader.scss";

const Loader = () => {
  const { loading } = useLoading();

  return (
    <AnimatePresence>
      {loading && (
        <motion.div
          className="novian-loader-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div className="novian-loader-content">
            <div className="dual-ring-spinner" />
            <p className="novian-loader-text">
              <strong>Cargando</strong><span className="dots">...</span>
            </p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Loader;